







import { Component } from 'vue-property-decorator';
import BaseView from '@/views/BaseView.vue';

@Component
export default class ExamGuide extends BaseView {
  private isTop = false;

  private mounted() {
    this.isTop = this.$route.path === this.paths.TOP;
  }

  private scrollToAnchor(anchor: string) {
    this.$scrollTo(anchor);
  }
}
